import { setDependentAnswerPreset, setDirectAnswerPreset } from "../..";
import { GLOBAL_PRESETS } from "../presets";
import { TAnswerFlow } from "../types";
import * as beautyUtils from "../utils";

export const HAIRCOLOR_ANSWER_FLOWS: Record<number, TAnswerFlow> = {
  0: setDirectAnswerPreset(
    undefined,
    "L'Oreal Hair Color Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the L'Oreal Hair Color category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircolor.loreal_oos_before()
  ),
  1: setDirectAnswerPreset(
    undefined,
    "Garnier Hair Color Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the Garnier Hair Color category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircolor.garnier_oos_before()
  ),
  2: setDirectAnswerPreset(
    undefined,
    "Dark & Lovely Hair Color Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the Dark & Lovely Hair Color category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircolor.darknlovely_oos_before()
  ),
  3: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of L'Oreal Hair Color you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircolor.loreal_stocked()
  ),
  4: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of Garnier Hair Color you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircolor.garnier_stocked()
  ),
  5: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of Dark & Lovely Hair Color you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircolor.darknlovely_stocked()
  ),
  6: setDependentAnswerPreset(
    undefined,
    "L'Oreal Hair Color: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [3],
    beautyUtils.getAfterOOSCount
  ),
  7: setDependentAnswerPreset(
    undefined,
    "Garnier Hair Color: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [4],
    beautyUtils.getAfterOOSCount
  ),
  8: setDependentAnswerPreset(
    undefined,
    "Dark & Lovely Hair Color: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [5],
    beautyUtils.getAfterOOSCount
  ),
  // 9: setDependentAnswerPreset(
  //   /Hair Color.Colorsonic|Colorsonic.Hair Color/i,
  //   "Select why 0 Items needed a count correction",
  //   "radio",
  //   [6, 7, 8],
  //   beautyUtils.getWhyZeroItemsNeededCountCorrection
  // ),
  10: setDependentAnswerPreset(
    undefined,
    "L'Oreal Hair Color: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [6],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  11: setDependentAnswerPreset(
    undefined,
    "Garnier Hair Color: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [7],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  12: setDependentAnswerPreset(
    undefined,
    "Dark & Lovely Hair Color: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [8],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  13: setDependentAnswerPreset(
    undefined,
    "L'Oreal Hair Color: What is the total number DPCIs in which the counts WERE CORRECTED",
    "text",
    [10],
    beautyUtils.getTotalDPCIsCountCorrected
  ),
  14: setDependentAnswerPreset(
    undefined,
    "Garnier Hair Color: What is the total number DPCIs in which the counts WERE CORRECTED",
    "text",
    [11],
    beautyUtils.getTotalDPCIsCountCorrected
  ),
  15: setDependentAnswerPreset(
    undefined,
    "Dark & Lovely Hair Color: What is the total number DPCIs in which the counts WERE CORRECTED",
    "text",
    [12],
    beautyUtils.getTotalDPCIsCountCorrected
  ),
  16: setDependentAnswerPreset(
    undefined,
    "Did a Team Lead assist you during your service to correct any Hair Color",
    "radio",
    [10, 11, 12],
    beautyUtils.getDidATeamMemberAssistYouWithUpdatingOnHands
  ),
};
